import { Box } from '@chakra-ui/react';

import { CheckCircleIcon } from 'Asset/icon';
import useIsMobile from 'Hook/useIsMobile';
import { TextRegular } from 'UiKit/typography';

import styles from './styles.module.css';

const ChecklistItem = ({ text, isActive }) => {
  const isMobile = useIsMobile();

  return (
    <Box className={styles['checklist__item']}>
      <CheckCircleIcon color={isActive ? 'var(--color-success60)' : 'var(--color-neutral40)'} size={isMobile ? '18px' : '20px'} />
      <TextRegular>{text}</TextRegular>
    </Box>
  );
};

export default ChecklistItem;
